import { TargetPreference } from '#/socket/document.type';
import AdminProfileIcon from '../../assets/icons/account-key.svg';
import ProfileIcon from '../../assets/icons/account.svg';
import StreamIcon from '../../assets/icons/broadcast.svg';
import StatisticsIcon from '../../assets/icons/chart-bar.svg';
import TariffIcon from '../../assets/icons/currency-usd.svg';
import GiftIcon from '../../assets/icons/gift.svg';
import HelpIcon from '../../assets/icons/help-circle-outline.svg';
import SupportIcon from '../../assets/icons/lifebuoy.svg';
import HomeIcon from '../../assets/icons/home-circle.svg';
import InvoiceIcon from '../../assets/icons/invoice.svg';
import LayersIcon from '../../assets/icons/layers.svg';
import ContactIcon from '../../assets/icons/message-processing-outline.svg';
import ChatsIcon from '../../assets/icons/message-text.svg';
import SparklingIcon from '../../assets/icons/sparkling.svg';
import { Route } from './WebNavigation';

export const ROUTES: Route[] = [
  {
    name: 'Home',
    screens: ['Home'],
    href: '/home',
    icon: HomeIcon,
    showForWhiteLabel: false,
  },
  {
    name: 'Admin Profile',
    screens: ['AdminProfile'],
    href: '/admin-profile',
    icon: AdminProfileIcon,
    businessIndent: true,
    hideForBusinessUsers: true,
    admin: true,
  },
  {
    name: 'Live stream',
    screens: ['ActiveStream', 'Stream'],
    href: '/stream',
    icon: StreamIcon,
    activeIfStreaming: true,
    businessIndent: true,
  },
  {
    name: 'Chats',
    screens: ['Chats'],
    icon: ChatsIcon,
    href: '/chats',
    businessIndent: true,
    showForChatsConfigured: true,
    showForTarget: TargetPreference.Adult,
  },
  {
    name: 'Overlays',
    screens: ['Overlays'],
    href: '/overlays',
    businessIndent: true,
    icon: LayersIcon,
  },
  {
    name: 'Statistics',
    screens: ['Statistics'],
    href: '/statistics',
    icon: StatisticsIcon,
    hideForBusinessUsers: true,
    businessIndent: true,
    requireCompleteProfile: true,
  },
  {
    name: 'Profile',
    screens: ['Profile', 'Billing'],
    href: '/profile',
    icon: ProfileIcon,
    hideForBusinessUsers: true,
    businessIndent: true,
  },
  {
    name: 'Pricing plans',
    screens: ['Tariff'],
    href: '/tariff',
    icon: TariffIcon,
    hideForBusinessUsers: true,
    businessIndent: true,
  },
  {
    name: 'Support',
    screens: ['Support'],
    href: '/support',
    icon: SupportIcon,
    businessIndent: true,
    hideForBusinessUsers: true,
    ifConfig: 'supportEnabled',
  },
  {
    name: 'Billing',
    screens: ['AdminBilling'],
    href: '/admin-billing',
    icon: InvoiceIcon,
    admin: true,
    ifConfig: 'billingEnabled',
  },
  {
    name: 'Refer a friend',
    screens: ['ReferAFriend'],
    href: '/refer-a-friend',
    icon: GiftIcon,
    hideForBusinessUsers: true,
    hideForBusiness: false,
    requireCompleteProfile: true,
  },
  {
    name: 'Help',
    screens: [],
    href: 'https://docs.streamster.io/',
    icon: HelpIcon,
    showForWhiteLabel: false,
  },
  {
    name: 'Contact us',
    screens: [],
    href: 'https://help.streamster.io/support/tickets/new',
    icon: ContactIcon,
    showForWhiteLabel: false,
  },
  {
    name: 'CamGems',
    screens: [],
    href: 'https://camgems.com/',
    icon: SparklingIcon,
    showForTarget: TargetPreference.Adult,
    showForWhiteLabel: false,
  },
];
